import * as Sentry from "@sentry/nextjs";
import { Extras } from "@sentry/types";
import { useTranslation } from "next-i18next";

import { CustomErrorEnum } from "@/consts/CustomErrorEnum";
import { useSnackbar } from "@/features/common/hooks/snackbar/useSnackbar";
import { useDialog } from "@/features/common/hooks/useDialog";

export const useErrorHandling = () => {
  const { t } = useTranslation("common");
  const { openSnackbar } = useSnackbar();
  const { closeDialog } = useDialog();
  const handleEthError = ({
    extra,
    error,
    functionName,
    messageForUnmatchedError,
  }: {
    extra?: Extras;
    functionName: string;
    error: any;
    messageForUnmatchedError?: string;
  }) => {
    if (error.message.includes(CustomErrorEnum.InsufficientFunds))
      return openSnackbar({
        message: t("common:nft.errors.insufficientFunds"),
        severity: "error",
      });
    if (error.message.includes("Failed to authorize transaction"))
      return openSnackbar({
        message: t("common:nft.errors.userDeclineTransaction"),
        severity: "error",
      });
    if (error.code === 4001) {
      openSnackbar({
        message: t("common:nft.errors.userDeclineTransaction"),
        severity: "error",
      });
      return;
    }
    closeDialog();
    openSnackbar({
      message:
        messageForUnmatchedError ?? t("common:nft.errors.transactionFail"),
      severity: "error",
    });
    Sentry.captureException(error, {
      tags: { eth721Contract: functionName },
      extra,
    });
  };

  return { handleEthError };
};
